// Load dependencies
import './bootstrap';
import './form-effects';
import './init-vue';
import './init-lang';

// Init Vue app
const app = new Vue({
    el: '#app',
    methods: {
        deleteUsingForm(formId) {
            return () => {
                document.getElementById(formId).submit();
            }
        }
    }
});
